<!-- RecipeSuggestions.svelte -->
<script>
    import { createEventDispatcher } from 'svelte';
    import { getIngredientMatchPercentage, selectedIngredients } from '../store.js';
    
    export let recipes = [];
    
    const dispatch = createEventDispatcher();
    
    function selectRecipe(recipe) {
      dispatch('selectRecipe', recipe);
    }
    
    function formatIngredients(ingredients) {
      return ingredients.map(ing => `${ing.amount} ${ing.name}`).join(', ');
    }

    // Calculate match percentage for each recipe
    $: recipesWithMatches = recipes.map(recipe => ({
      ...recipe,
      matchPercentage: getIngredientMatchPercentage(recipe, $selectedIngredients)
    }));
</script>
  
<div class="recipe-suggestions">
  {#if recipes.length === 0}
    <p class="no-suggestions">Inga receptförslag hittades baserat på valda råvaror</p>
  {:else}
    <div class="recipes-grid">
      {#each recipesWithMatches as recipe}
        <div class="recipe-card" on:click={() => selectRecipe(recipe)}>
          <div class="recipe-match">
            <div class="match-progress">
              <div class="match-bar" style="width: {recipe.matchPercentage}%"></div>
            </div>
            <span class="match-text">{recipe.matchPercentage}% matchande ingredienser</span>
          </div>
          
          <div class="recipe-header">
            <div class="placeholder-image">{recipe.name.charAt(0)}</div>
            <h3>{recipe.name}</h3>
          </div>
          
          <div class="recipe-meta">
            <span class="prep-time">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              {recipe.prepTime} min
            </span>
            
            <span class="difficulty">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
              {recipe.difficulty}
            </span>
            
            <span class="category">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
              </svg>
              {recipe.category}
            </span>
          </div>
          
          <div class="ingredients">
            <strong>Ingredienser:</strong> {formatIngredients(recipe.ingredients)}
          </div>
          
          <button class="view-details-button">
            Visa recept
          </button>
        </div>
      {/each}
    </div>
  {/if}
</div>
  
<style>
  .recipe-suggestions {
    width: 100%;
  }
  
  .recipes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
  }
  
  .recipe-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    background-color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
  }
  
  .recipe-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
  
  .recipe-match {
    padding: 15px 15px 5px 15px;
  }
  
  .match-progress {
    width: 100%;
    height: 8px;
    background-color: #eee;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 5px;
  }
  
  .match-bar {
    height: 100%;
    background-color: #4caf50;
    border-radius: 10px;
  }
  
  .match-text {
    font-size: 14px;
    color: #666;
  }
  
  .recipe-header {
    background-color: #f5f5f5;
    padding: 15px;
    display: flex;
    align-items: center;
  }
  
  .placeholder-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #e91e63;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    margin-right: 10px;
  }
  
  h3 {
    margin: 0;
    color: #333;
    font-size: 18px;
  }
  
  .recipe-meta {
    display: flex;
    padding: 10px 15px;
    background-color: #f9f9f9;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
  
  .recipe-meta span {
    display: flex;
    align-items: center;
    margin-right: 15px;
    font-size: 14px;
    color: #666;
  }
  
  .recipe-meta svg {
    margin-right: 5px;
  }
  
  .ingredients {
    padding: 15px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    line-height: 1.5;
    max-height: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  
  .view-details-button {
    width: 100%;
    padding: 10px;
    background-color: #e91e63;
    border: none;
    color: white;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .view-details-button:hover {
    background-color: #d81b60;
  }
  
  .no-suggestions {
    text-align: center;
    padding: 20px;
    color: #666;
    background-color: #f9f9f9;
    border-radius: 8px;
    border: 1px dashed #ddd;
  }
</style>